import { Box, Grid, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors } from "../../../theme/theme";
import OverviewBox from "../../Common/OverviewBox";
import {
  AccountCircleOutlined,
  BusinessOutlined,
  EventOutlined,
  FormatQuoteOutlined,
  LanguageOutlined,
} from "@mui/icons-material";
import { pointsData } from "../../../assets/data";
import { CustomBtn } from "../../Common/CustomBtn";
import dayjs from "dayjs";

const tabs = [
  { id: 1, name: "About" },
  { id: 2, name: "Photos" },
  { id: 3, name: "References" },
];

const ProfileBox = ({ user }) => {
  const [selectedTab, setSelectedTab] = useState(1);
  return (
    <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", p: 2, mt: 2 }}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            color: colors.primary,
            fontFamily: "Mulish-Medium",
            fontSize: "16px",
          }}
        >
          Last login less than a minute ago
        </Typography>
        <Box
          sx={{
            border: "1px solid rgba(25,34,52,0.14)",
            borderRadius: "8px",
            p: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {tabs.map((tab) => (
            <Box
              sx={{
                borderRadius: "5px",
                cursor: "pointer",
                backgroundColor:
                  selectedTab === tab.id ? colors.secondary : "transparent",
                color: selectedTab === tab.id ? "#fff" : colors.primary,
                fontFamily:
                  selectedTab === tab.id ? "Mulish-SemiBold" : "Mulish-Regular",
                fontSize: "14px",
                px: 1.5,
                py: 0.5,
                "&:hover": {
                  backgroundColor:
                    selectedTab === tab.id ? colors.secondary : "#f0f0f0",
                  color: selectedTab === tab.id ? "#fff" : colors.primary,
                },
              }}
              key={tab.id}
              onClick={() => setSelectedTab(tab.id)}
            >
              {tab.name}
            </Box>
          ))}
        </Box>
      </Stack>

      <Typography
        sx={{
          color: colors.primary,
          fontFamily: "Mulish-ExtraBold",
          fontSize: "18px",
          mt: 2,
        }}
      >
        Overview
      </Typography>
      <Grid container spacing={2} mt={2}>
        <Grid item size={{ xs: 12, sm: 3 }}>
          <OverviewBox Icon={FormatQuoteOutlined} text={"Reviews"} value={0} />
        </Grid>
        <Grid item size={{ xs: 12, sm: 3 }}>
          <OverviewBox
            Icon={LanguageOutlined}
            text={"No Languages Listed"}
            value={0}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 3 }}>
          <OverviewBox
            Icon={EventOutlined}
            text={"Member since"}
            value={dayjs(user?.createdAt).format("MM YYYY") || "N/A"}
          />
        </Grid>
        <Grid item size={{ xs: 12, sm: 3 }}>
          <OverviewBox
            Icon={BusinessOutlined}
            text={"No occupation listed"}
            value={0}
          />
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid
          item
          size={{ xs: 12, sm: 6 }}
          sx={{
            borderRight: "2px solid rgba(25,34,52,0.09)",
            pr: 2,
          }}
        >
          <Typography
            sx={{
              color: colors.primary,
              fontFamily: "Mulish-ExtraBold",
              fontSize: "18px",
              mt: 2,
            }}
          >
            Points
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              my: 4,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                color: colors.secondary,
                fontFamily: "Mulish-ExtraBold",
                fontSize: "75px",
                lineHeight: "60px",
              }}
            >
              230
            </Typography>
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Medium",
                fontSize: "16px",
                textTransform: "uppercase",
              }}
            >
              pts Till now
            </Typography>
          </Box>

          <Typography
            sx={{
              color: colors.primary,
              fontFamily: "Mulish-Bold",
              fontSize: "12px",
              mt: 2,
            }}
          >
            Do more things to get more points!
          </Typography>
          {pointsData.map((point) => (
            <Box
              key={point.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                borderBottom: "1px solid rgba(25,34,52,0.09)",
                py: 1,
              }}
            >
              <Typography
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "14px",
                }}
              >
                {point.name}
              </Typography>
              <Typography
                sx={{
                  color: colors.primary,
                  fontFamily: "Mulish-Medium",
                  fontSize: "12px",
                }}
              >
                {point.points} pts
              </Typography>
            </Box>
          ))}
        </Grid>
        <Grid item size={{ xs: 12, sm: 6 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <AccountCircleOutlined
              sx={{ color: colors.secondary, fontSize: "40px" }}
            />
            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Medium",
                fontSize: "14px",
                my: 2,
                maxWidth: "300px",
                textAlign: "center",
              }}
            >
              We decide whom to meet based on profiles! Until you fill out your
              profile, people won’t know what to expect and why they should hang
              out with you.
            </Typography>

            <CustomBtn
              text={"Fill out my profile"}
              border={`1px solid ${colors.secondary}`}
              bgc={"#fff"}
              secondary
              color={colors.secondary}
              fontFamily={"Mulish-SemiBold"}
              fontSize={"14px"}
              width={"50%"}
              icon
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileBox;
